import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { setupWorker } from 'msw/browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { setupGoogleAnalytics } from './app/core/ga';
import { setupSentry } from './app/core/sentry';
import { environment } from './environments/environment';

const { kobitoApiEndpoint, sentry, googleAnalyticsTrackingId } = environment;

setupSentry(sentry);
setupGoogleAnalytics(googleAnalyticsTrackingId);

async function bootstrap() {
  if (kobitoApiEndpoint === null) {
    // モックAPIが起動するまでAngularの起動を待つ
    const mockApiWorker = await import('./api/mocks/handlers').then(
      ({ handlers }) => setupWorker(...handlers),
    );
    await mockApiWorker.start();
  }

  return bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
  });
}

bootstrap().catch((err) => console.error(err));
